<template>
    <Modal class-name="scrollable vertical-center-modal" title="Nueva Evaluación" v-model="show" :footer-hide="true" :scrollable="true">
        <Form style="width: 100%" ref="planForm" :model="evaluation" :rules="ruleInline">
            <Row :gutter="16">
                <i-col span="24">
                    <FormItem label="Nombre" prop="name">
                        <Input v-model="evaluation.name" placeholder="" />
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <Button style="margin-top: 25px" size="large" long type="primary" :loading="loading" @click="save">Agregar</Button>
                </i-col>
            </Row>
        </Form>
    </Modal>
</template>

<script>
    export default {
        data(){
            return {
                show: false,
                evaluation: {
                    name: "",
                },
                roles: [],
                loading: false,
                ruleInline: {
                    name: [
                        { required: true, message: 'Nombre es requerido', trigger: 'change' }
                    ],
                    roles: [
                        { required: true, type: 'array', message: 'Selecciona al menos un rol', trigger: 'change' }
                    ]
                },
            }
        },
        methods: {
            save(){
                this.$refs.planForm.validate(valid => {

                    if(valid){
                        this.loading = true
                        window.axios.post(this.$root.API_URL + '/evaluation/usr/create', { ...this.evaluation })
                        .then(response => {
                            if(response.data.success){
                                window.EventBus.$emit('evaluations--add-evaluation', response.data.evaluation)
                                this.show = false
                                this.loading = false
                                this.clear()
                            }
                        })
                        .catch(() => {
                            this.loading = false
                            this.$Message.error('Hubo un problema, no pudimos completar esta acción');
                        })
                    }
                })
            },
            clear(){
                this.evaluation =  {
                    name: "",
                }
            }
        },
        mounted(){
            window.EventBus.$on('evaluations--create-popup', () => {
                this.show = true
            })
        }
    }
</script>